import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
// import * as CrudServices from "../../../../../service/crudServices";
import { Checkbox, Input } from "antd";
import { IconSearch } from "../../../asset";
import { setGlobalIsGetDetail, setGlobalTrip } from "../../../store/reducer/globalMultipleSearchSelect.reducer";
import { GROLOG_ORDER_URL } from "../../../constant/apiConstant";
import axios from "axios";

const MSSTrip = ({
  setValueMSS,
  valueMSS,
  children,
  togglerClassName,
  placeholder,
  className,
  filterByGrologAccountId,
  ...attrs
}) => {
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const btnDropdownRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [listData, setListData] = useState([]);
  const [listSelected, setListSelected] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [totalData, setTotalData] = useState(null);
  const [isSelectedAll, setIsSelectedAll] = useState(false);
  const {
    globalOrderFrom,
    globalDepotName,
    globalDAStatus,
    globalDA,
    globalOrderStatus,
    globalTrip,
    globalTripStatus,
    globalIsGetDetail
  } = useSelector((state) => state.globalMSS);

  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(event?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  const getTotalData = useCallback(async () => {
    let datas ={
      "page" : 1,
      "limit" : 10,
      "order" : "",
      "connector" : "",
      "other" : {
        "depot": {
            "list_id": globalDepotName,
            "exclude": false
        },
          "delivery_associate": {
              "list_id": globalDA,
              "exclude": false
          },
          "trip_status": {
              "list": globalTripStatus,
              "exclude": false
          }
      }
  }
    let res = await doPost(`/all-trip/for-report/initiate`, token, datas);
    if (res?.data?.payload?.data !== null) {
      setTotalData(res?.data?.payload?.data?.count_data);
      return;
    }
    setTotalData(null);
  }, [token, globalDepotName, globalDA, globalTripStatus]);

  useEffect(() => {
    getTotalData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  
    
  useEffect(()=>{
    if(globalIsGetDetail){
    setListSelected(
      // globalDepotName.every(item => item >= 0) ? 
      // globalDepotName.map((item)=> {
      // return { id: item }}) : globalDepotName)
      globalTrip?.every(item => item >= 0)&& typeof globalTrip[0] !== 'object' ? 
      listData?.filter(itemB => globalTrip?.includes(itemB?.id)): globalTrip)
    
      dispatch(setGlobalIsGetDetail(false))
    }
    // dispatch(setGlobalIsGetDetail(true))
  },[globalTrip])

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const api = GROLOG_ORDER_URL;
    const url = api + endpoint;
    const method = "POST";
    const headers = {
      Authorization: token,
    };
    const request = { url, method, headers, data };
    return axios(request);
  };
  const getListTrip = useCallback(
    async (newParams) => {
      let datas ={
        ...newParams,
        "order" : "",
        "connector" : "",
        "other" : {
          "depot": {
              "list_id": globalDepotName?.length >0&& typeof globalDepotName[0] === 'object' ? globalDepotName?.map((el)=>el?.id) : globalDepotName,
              "exclude": false
          },
          "delivery_associate": {
              "list_id": globalDA?.length >0&& typeof globalDA[0] === 'object' ? globalDA?.map((el)=>el?.id) : globalDA,
              "exclude": false
          },
            "trip_status": {
                "list": globalTripStatus?.length >0&& typeof globalTripStatus[0] === 'object' ? globalTripStatus?.map((el)=>el?.id) : globalTripStatus,
                "exclude": false
            }
        }
    }
      let res = await doPost(`/all-trip/dropdown-report`, token, datas);

      if (res?.data?.payload?.data !== null) {
        const list = res?.data?.payload?.data.map((el) => {
          return {
            id: el?.id,
            trip_name: el?.trip_name,
          };
        });

        if (newParams?.filter && newParams?.filter.includes("trip_name")) {
          setListData([...list]);
          return;
        }
        list.unshift({ id: -1, trip_name: "Select All" });
        setListData([...list]);
      }
      if (res?.ok && res?.data === null) {
        setListData([{ id: -1, trip_name: "Select All" }]);
      }
    },
    [token,globalDepotName,globalDA,globalTripStatus]
  );

  const handleClickSelectData = useCallback(
    (item) => {
      if (item?.id === -1) {
        if (listSelected.length === 0 || !listSelected) {
          setListSelected([-1]);
          dispatch(setGlobalTrip([-1]));
          return;
        }
        if (listSelected.length && listSelected.length - 1 !== totalData) {
          if (listSelected.includes(-1)) {
            setListSelected([]);
            dispatch(setGlobalTrip([]));
            return;
          }
          setListSelected([-1]);
          dispatch(setGlobalTrip([-1]));
          return;
        }
        if (listSelected.length && listSelected.includes(-1)) {
          setListSelected([]);
          dispatch(setGlobalTrip([]));
        }

        return;
      }
      if (item?.id !== -1) {
        if (listSelected.length === 0) {
          const listDataSelected = listSelected;
          listDataSelected.push(item);
          setListSelected([...listDataSelected]);
          dispatch(setGlobalTrip([...listDataSelected]));
          return;
        }
        const isAllSelected = listSelected.includes(-1);

        if (isAllSelected) {
          const idFiltering = [-1];
          idFiltering.push(item?.id);
          const newList = listData.filter(
            (el) => !idFiltering.includes(el?.id)
          );
          setListSelected([...newList]);
          dispatch(setGlobalTrip([...newList]));
          return;
        }
        const isExist = listSelected.some((el) => el?.id === item?.id);
        if (isExist) {
          const listDataFiltered = listSelected.filter(
            (el) => el?.id !== item?.id
          );
          setListSelected([...listDataFiltered]);
          dispatch(setGlobalTrip([...listDataFiltered]));
          return;
        } else {
          const list = listSelected;
          list.unshift(item);
          setListSelected([...list]);
          dispatch(setGlobalTrip([...list]));
          return;
        }
      }
    },
    [dispatch, listData, listSelected, totalData]
  );

  const isCheckedSelectAll = useMemo(() => {
    if (listSelected !== undefined && listSelected.length === totalData) {
      setIsSelectedAll(true);
      return true;
    }
    setIsSelectedAll(false);
    return false;
  }, [listSelected, totalData]);

  const isCheckedPerItem = useCallback(
    (item) => {
      if (listSelected.length > 0) {
        if (listSelected.length === totalData || listSelected.includes(-1)) {
          return true;
        }
        const isExist = listSelected.some((el) => el.id === item.id);
        return isExist;
      }
      return false;
    },
    [listSelected, totalData]
  );

  const isAllTrip = useMemo(() => {
    if (listSelected.length) {
      if (listSelected.includes(-1)) {
        return true;
      }
      const length = listSelected.length;
      if (listSelected.length > 0 && length === totalData) {
        return true;
      }
    }
    return false;
  }, [listSelected, totalData]);

  const onChangeSearch = useCallback((val) => {
    setSearchKeyword(val);
  }, []);

  useEffect(() => {
    if (!searchKeyword &&globalDepotName&&globalTripStatus&&globalDA) {
      const resetParams = {
        page: 1,
        limit: 100,
      };
      getListTrip(resetParams);
      return;
    }
    if(searchKeyword &&globalDepotName&&globalTripStatus&&globalDA){
    const newParams = {
      page: 1,
      limit: 100,
      filter: `trip_name lk ${searchKeyword}`,
    };
    getListTrip(newParams);

  }
  }, [filterByGrologAccountId, getListTrip, searchKeyword, globalDepotName,globalTripStatus,globalDA]);

  return (
    <div
      className={"dropdown-dds".concat(className ? ` ${className}` : "")}
      {...attrs}
      ref={dropdownRef}
    >
      <button
        className={`value-mss`}
        onClick={togglerDropdownContent}
        ref={btnDropdownRef}
        disabled={!globalDA||!globalDepotName||!globalTripStatus}
      >
        {isAllTrip ? (
          <span className="list-value-mss">All Trip</span>
        ) : isCheckedSelectAll === false && listSelected.length !== 0 ? (
          listSelected.map((item, index) => (
            <span key={index} className="list-value-mss">
              {item?.trip_name}
            </span>
          ))
        ) : (
          <span className="placeholder-mss">Select Trip</span>
        )}
      </button>
      <div></div>
      <div
        className={"dropdown-dds-menu".concat(
          isShowDropdownContent ? " active mt-2 pb-10" : ""
        )}
        ref={dropdownContentRef}
      >
        <div className="my-2 px-2">
          <Input
            placeholder="Search By Trip Name"
            size="large"
            suffix={<img src={IconSearch} alt="icon-search" />}
            onChange={(evt) => onChangeSearch(evt.target.value)}
          />
        </div>
        <div className="overflow-auto max-h-[300px]">
          {listData?.map((el, index) => (
            <div
              key={index}
              className={"dropdown-dds-item truncate"}
              onClick={() => handleClickSelectData(el)}
            >
              <div className="w-full flex justify-between px-2">
                <span>{el?.trip_name}</span>
                <Checkbox checked={isCheckedPerItem(el)} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MSSTrip;
